/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'gmail': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<g id="comp_x5F_147-gmail"><path pid="0" d="M397.89 83.035H114.106l141.897 112.351zM102.498 197.958v231.007h306.998V197.934l-153.491 118.41z"/><path pid="1" d="M442.871 83.035h-14.375L256.003 219.621 83.498 83.035H69.125c-23.803 0-43.124 19.37-43.124 43.241v259.446c0 23.867 19.321 43.24 43.124 43.24h14.373v-269.65L256.003 292.35l172.493-133.07v269.684h14.375c23.806 0 43.128-19.373 43.128-43.24V126.276c0-23.87-19.319-43.241-43.128-43.241z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/gmail.js